/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map


/* Spada: Collection image toggle (Modelled / Mannequin) */
(() => {
  if (window.__spadaImageToggleInit) return;
  window.__spadaImageToggleInit = true;

  const STORAGE_KEY = "spada_collection_image_view";
  const DEFAULT_VIEW = "model"; // "model" | "ghost"

  const getView = () => {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === "ghost" || v === "model" ? v : DEFAULT_VIEW;
  };

  const setView = (view) => {
    window.localStorage.setItem(STORAGE_KEY, view);
  };

  const setActiveButtonUI = (view) => {
    document.querySelectorAll("[data-spada-image-toggle-ui]").forEach((wrap) => {
      wrap.querySelectorAll("button[data-spada-view]").forEach((btn) => {
        const isActive = btn.getAttribute("data-spada-view") === view;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    });
  };

  const updateCardImage = (card, view) => {
    const src =
      view === "ghost"
        ? card.getAttribute("data-spada_img_ghost-src")
        : card.getAttribute("data-spada_img_modelled-src");

    const srcset =
      view === "ghost"
        ? card.getAttribute("data-spada_img_ghost-srcset")
        : card.getAttribute("data-spada_img_modelled-srcset");

    if (!src || !srcset) return;

    // Most themes: img has these classes
    const img =
      card.querySelector("img.js-product-card-image") ||
      card.querySelector("img.product-card__img") ||
      card.querySelector("img");

    if (!img) return;

    // Handle themes using lazy-loading attributes too
    img.setAttribute("src", src);
    img.setAttribute("srcset", srcset);

    if (img.hasAttribute("data-src")) img.setAttribute("data-src", src);
    if (img.hasAttribute("data-srcset")) img.setAttribute("data-srcset", srcset);

    // Some themes wrap in <picture><source ...>
    const picture = img.closest("picture");
    if (picture) {
      picture.querySelectorAll("source").forEach((source) => {
        if (source.hasAttribute("srcset")) source.setAttribute("srcset", srcset);
        if (source.hasAttribute("data-srcset")) source.setAttribute("data-srcset", srcset);
      });
    }
  };

  const applyViewToCards = (root = document) => {
    const view = getView();
    setActiveButtonUI(view);

    root
      .querySelectorAll("product-card[data-spada-image-toggle]")
      .forEach((card) => updateCardImage(card, view));
  };

  const bindClicks = () => {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("button[data-spada-view]");
      if (!btn) return;

      const wrap = btn.closest("[data-spada-image-toggle-ui]");
      if (!wrap) return;

      const view = btn.getAttribute("data-spada-view");
      if (view !== "model" && view !== "ghost") return;

      setView(view);
      applyViewToCards(document);
    });
  };

  const watchForAjaxUpdates = () => {
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;

          // If new product cards are injected, re-apply
          if (
            node.matches?.("product-card[data-spada-image-toggle]") ||
            node.querySelector?.("product-card[data-spada-image-toggle]")
          ) {
            applyViewToCards(node);
          }
        }
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });
  };

  const init = () => {
    bindClicks();
    applyViewToCards(document);
    watchForAjaxUpdates();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
/* =========================================================
   Spada: Collection image toggle (Modelled / Mannequin)
   Works with dynamic-product-search re-rendering
========================================================= */
(() => {
  const STORAGE_KEY = "spada_card_image_view"; // "model" | "ghost"
  const DEFAULT_VIEW = "model";

  const getSavedView = () => {
    const v = window.localStorage ? localStorage.getItem(STORAGE_KEY) : null;
    return v === "ghost" || v === "model" ? v : DEFAULT_VIEW;
  };

  const saveView = (view) => {
    if (!window.localStorage) return;
    localStorage.setItem(STORAGE_KEY, view);
  };

  const setActiveButtons = (root, view) => {
    const ui = root.querySelector("[data-spada-image-toggle-ui]");
    if (!ui) return;

    const buttons = ui.querySelectorAll("button[data-spada-view]");
    buttons.forEach((btn) => {
      const isActive = btn.getAttribute("data-spada-view") === view;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  };

  const applyViewToCard = (cardEl, view) => {
    if (!cardEl || !cardEl.getAttribute) return;

    const modelSrc = cardEl.getAttribute("data-spada_img_modelled-src");
    const modelSrcset = cardEl.getAttribute("data-spada_img_modelled-srcset");
    const ghostSrc = cardEl.getAttribute("data-spada_img_ghost-src");
    const ghostSrcset = cardEl.getAttribute("data-spada_img_ghost-srcset");

    const img = cardEl.querySelector("img.js-product-card-image, img.product-card__img");
    if (!img) return;

    // Pick target based on view, but gracefully fall back if missing
    const targetSrc = view === "ghost" ? ghostSrc : modelSrc;
    const targetSrcset = view === "ghost" ? ghostSrcset : modelSrcset;

    if (!targetSrc) return; // nothing to swap to

    img.src = targetSrc;
    if (targetSrcset) img.srcset = targetSrcset;
  };

  const applyViewToAllCards = (root, view) => {
    const cards = root.querySelectorAll("[data-spada-image-toggle]");
    if (!cards.length) return;
    cards.forEach((card) => applyViewToCard(card, view));
  };

  const applyEverywhere = (view) => {
    // update all toggle UIs
    document.querySelectorAll("[data-spada-image-toggle-ui]").forEach((ui) => {
      setActiveButtons(document, view);
    });

    // update cards
    applyViewToAllCards(document, view);
  };

  const init = () => {
    // Set initial view from storage
    const initialView = getSavedView();
    setActiveButtons(document, initialView);
    applyViewToAllCards(document, initialView);

    // Click handling (event delegation)
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("button[data-spada-view]");
      if (!btn) return;

      const ui = btn.closest("[data-spada-image-toggle-ui]");
      if (!ui) return;

      const view = btn.getAttribute("data-spada-view");
      if (view !== "model" && view !== "ghost") return;

      saveView(view);
      setActiveButtons(document, view);
      applyViewToAllCards(document, view);
    });

    // Watch for dynamic-product-search updates (filters/sort/pagination)
    const resultsRoot =
      document.querySelector("dynamic-product-search") ||
      document.querySelector(".js-results-container") ||
      document.body;

    const obs = new MutationObserver(() => {
      const view = getSavedView();
      setActiveButtons(document, view);
      applyViewToAllCards(document, view);
    });

    obs.observe(resultsRoot, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


// ===============================
// Spada: Collection card image toggle (Modelled / Mannequin)
// ===============================
(() => {
  const STORAGE_KEY = "spadaCardView";
  const DEFAULT_VIEW = "model"; // "model" | "ghost"

  const getView = () => {
    const v = window.localStorage?.getItem(STORAGE_KEY);
    return v === "ghost" || v === "model" ? v : DEFAULT_VIEW;
  };

  const setView = (view) => {
    try {
      window.localStorage?.setItem(STORAGE_KEY, view);
    } catch (e) {}
  };

  const setActiveButtons = (view) => {
    document.querySelectorAll("[data-spada-image-toggle-ui]").forEach((wrap) => {
      wrap.querySelectorAll("[data-spada-view]").forEach((btn) => {
        const isActive = btn.getAttribute("data-spada-view") === view;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    });
  };

  const applyViewToCard = (card, view) => {
    if (!card) return;

    const modelSrc = card.getAttribute("data-spada_img_modelled-src");
    const modelSrcset = card.getAttribute("data-spada_img_modelled-srcset");
    const ghostSrc = card.getAttribute("data-spada_img_ghost-src");
    const ghostSrcset = card.getAttribute("data-spada_img_ghost-srcset");

    const targetSrc = view === "ghost" ? ghostSrc : modelSrc;
    const targetSrcset = view === "ghost" ? ghostSrcset : modelSrcset;

    // If the chosen view doesn't exist on this product, do nothing.
    if (!targetSrc || !targetSrcset) return;

    // Theme image snippet usually renders an <img> with this class (you have it in your snippet)
    const img =
      card.querySelector("img.js-product-card-image") ||
      card.querySelector(".js-product-card-image img") ||
      card.querySelector("img");

    if (!img) return;

    // Prevent unnecessary swaps
    if (img.getAttribute("src") === targetSrc && img.getAttribute("srcset") === targetSrcset) return;

    img.setAttribute("src", targetSrc);
    img.setAttribute("srcset", targetSrcset);

    // If theme uses lazyloading data attributes, set those too (harmless if unused)
    img.setAttribute("data-src", targetSrc);
    img.setAttribute("data-srcset", targetSrcset);

    card.setAttribute("data-spada-current-view", view);
  };

  const applyView = (view) => {
    setActiveButtons(view);
    document.querySelectorAll("product-card[data-spada-image-toggle]").forEach((card) => {
      applyViewToCard(card, view);
    });
  };

  const init = () => {
    // 1) Apply saved/default view on load
    applyView(getView());

    // 2) Click handling (event delegation)
    document.addEventListener("click", (e) => {
      const btn = e.target?.closest?.("[data-spada-view]");
      if (!btn) return;

      const view = btn.getAttribute("data-spada-view");
      if (view !== "model" && view !== "ghost") return;

      setView(view);
      applyView(view);
    });

    // 3) Re-apply when products are re-rendered by dynamic search / filters / pagination
    const observer = new MutationObserver((mutations) => {
      const view = getView();
      let shouldReapply = false;

      for (const m of mutations) {
        if (m.type !== "childList") continue;

        // If any product-card is added, re-apply
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.("product-card[data-spada-image-toggle]") || node.querySelector?.("product-card[data-spada-image-toggle]")) {
            shouldReapply = true;
            break;
          }
        }

        if (shouldReapply) break;
      }

      if (shouldReapply) applyView(view);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  // global.js is loaded as type="module" + defer, so DOM is typically ready,
  // but we’ll be safe:
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

